import { Injectable, inject } from '@angular/core';
import { Project, ProjectsStore } from '@dges/modules/portfolio/domain';
import { Actions, ofType } from '@ngrx/effects';

import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as ProjectsActions from './projects.actions';
import * as ProjectsSelectors from './projects.selectors';

@Injectable()
export class ProjectsFacade implements ProjectsStore {
  private store = inject(Store);
  private actions$ = inject(Actions);

  loaded$ = this.store.pipe(select(ProjectsSelectors.getProjectsLoaded));
  allItems$ = this.store.pipe(select(ProjectsSelectors.getAllProjects));
  selectedItem$ = this.store.pipe(select(ProjectsSelectors.getSelected));

  load() {
    this.store.dispatch(ProjectsActions.loadProjects());
    return this.allItems$;
  }

  addItem(project: Project) {
    this.store.dispatch(ProjectsActions.addProject({ project }));
  }

  editItem(project: Project) {
    this.store.dispatch(ProjectsActions.editProject({ project }));
  }

  deleteItem(project: Project) {
    this.store.dispatch(ProjectsActions.deleteProject({ project }));
  }

  editOrAddSuccess(): Observable<Actions> {
    return this.actions$.pipe(
      ofType(
        ProjectsActions.addProjectSuccess,
        ProjectsActions.editProjectSuccess,
      ),
    );
  }
}
